@import 'styles/mixins';
@import 'styles/variables';

.headline {
  line-height: 28px;
  margin-bottom: 14px;
}

.compactHeadline {
  @extend .headline;

  margin-bottom: 4px;
}

.subHeadline {
  color: var(--neutral-40);
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.inviteSubtext {
  @include md-regular;
  color: var(--neutral-40);

  margin-bottom: 20px;
}

.addMemberContainer {
  margin-bottom: 64px;
  position: relative;
}

.hasOverlay {
  opacity: 0.3;
}

.membersContainer {
  padding-bottom: 30px;
}

.inviteUrlContainer {
  margin-bottom: 64px;
}

.banner {
  @include ui-md-text;

  align-items: center;
  border-radius: 6px;
  color: var(--neutral-60);
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  padding: 28px 40px;
  width: 100%;

  .bannerLink {
    color: var(--action-60);
    margin-top: 8px;

    &:hover {
      color: var(--action-60);
      cursor: pointer;
    }
  }

  .buttonText {
    margin-right: 8px;
  }
}

.cancelText {
  @include ui-sm-text;

  color: var(--neutral-40);
  margin-top: 12px;
  text-align: center;

  .contactUsLink {
    color: var(--neutral-60);
    font-weight: 600;
  }
}

.paying {
  background-color: var(--action-50);
}

.earlyAdopter {
  background-color: $orange-10;
}

.atPaywall {
  background-color: #fff7e8;
}

.freePlan {
  background-color: var(--neutral-3);
}

.overlay {
  @include z-index(overlay);

  display: flex;
  justify-content: center;
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translate(-50%, 0%);

  .signupOverlay {
    background-color: #fff7e8;
    box-shadow: 0px 1px 0px rgba(19, 21, 26, 0.12);
    border-radius: 6px;
    max-width: 450px;
    padding: 26px 30px;

    .signupHeader {
      @include header-md;

      color: var(--neutral-90);
    }

    .signupHelpText {
      color: var(--neutral-50);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
      margin-bottom: 20px;
      margin-top: 8px;
    }

    .signupButtonText {
      margin-right: 8px;
    }
  }
}

.upgradeToGrowthButton {
  position: absolute;
  top: 12px;
  right: 50px;
  background: #6a00ff1a 10% !important;
  color: #6a00ff !important;
  font-weight: 400;
}
